import { ChevronDown } from 'lucide-react';
import { Button } from '../components/ui/button';

const Home = () => {
  const scrollToRooms = () => {
    const element = document.getElementById('rooms');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/images/pic_9.jpeg')",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-jungle-900/90 via-jungle-900/40 to-jungle-900/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-8 max-w-4xl mx-auto">
        {/* Accent Line */}
        <div className="w-20 h-0.5 bg-earth-400 mx-auto mb-8" />

        {/* Subtitle */}
        <p
          data-testid="hero-subtitle"
          className="font-sans text-sm md:text-base tracking-[0.3em] uppercase text-white/80 mb-6"
        >
          Welcome to
        </p>

        {/* Main Title */}
        <h1
          data-testid="hero-title"
          className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-4"
        >
          Jungle Villa
        </h1>

        {/* Tagline */}
        <p
          data-testid="hero-tagline"
          className="font-accent text-xl md:text-2xl text-earth-300 italic mb-4"
        >
          & Restaurant
        </p>

        {/* Location */}
        <p
          data-testid="hero-location"
          className="font-sans text-lg md:text-xl text-white/70 tracking-wide mb-12"
        >
          Mount Abu's Premier Nature Retreat
        </p>

        {/* CTA Button */}
        <Button
          data-testid="hero-cta"
          onClick={scrollToRooms}
          className="bg-earth-400 hover:bg-earth-500 text-jungle-900 font-sans font-semibold text-sm tracking-wider uppercase px-10 py-6 rounded-full transition-transform hover:scale-105"
        >
          Explore Rooms
        </Button>

        {/* Scroll Indicator */}
        <div
          data-testid="scroll-indicator"
          className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce cursor-pointer"
          onClick={scrollToRooms}
        >
          <ChevronDown className="w-8 h-8 text-white/60" />
        </div>
      </div>
    </section>
  );
};

export default Home;
